<template>
  <div
    class="deposit-models deposit-models--result"
    :class="[
      { 'is-scrolled': isScrollable && !isScrolledToEnd },
      {
        'last-selected':
          activeDepositModel.indexOf(
            depositModels[depositModels.length - 1].name
          ) != -1
      }
    ]"
    ref="depositmodels"
    v-resize:debounce.50="updateScrollableState"
  >
    <div
      class="deposit-models__content"
      ref="depositmodelcontent"
      @scroll="onScroll"
    >
      <div
        class="deposit-model-wrap deposit-model-container"
        v-for="(model, index) in depositModels"
        v-bind:key="index"
        :class="{
          'is-selected': activeDepositModel.indexOf(model.name) != -1,
          'is-active': activeDepositModelTab.indexOf(model.name) != -1,
          'is-recommended': model.name == recommendedDeposit
        }"
        @click="triggerCompareView(index)"
      >
        <div
          class="deposit-model-recommendation"
          v-if="model.name == recommendedDeposit"
        >
          <svg width="20" height="19">
            <use xlink:href="#icon-star" />
          </svg>
          {{ $t("depotfinder.results.recommendation") }}
        </div>
        <button class="deposit-model-button" @click="triggerCompareView(index)">
          <div class="deposit-model">
            <div class="deposit-model__icon">
              <svg width="64" height="64">
                <use v-bind:xlink:href="getDepotsitModelIcon(model.name)" />
              </svg>
            </div>
            <span class="deposit-model__name" v-if="window.width >= 600">{{
              $t(`depositmodels.${model.name}.name`)
            }}</span>
            <span class="deposit-model__name" v-else>{{
              $t(`depositmodels.${model.name}.shortname`)
            }}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import resize from "vue-resize-directive";
export default {
  directives: {
    resize
  },
  props: {
    recommendedDeposit: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      isScrollable: false,
      isScrolledToEnd: false
    };
  },
  computed: {
    depositModels() {
      return this.$store.getters.getFilteredDepositModels;
    },
    activeDepositModel() {
      return this.$store.getters.getActiveDeposit;
    },
    activeDepositModelTab() {
      return this.$store.getters.getActiveDepositTab;
    }
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getDepotsitModelIcon(model) {
      return "#icon-" + model.toLowerCase();
    },
    triggerCompareView(model) {
      let modelName = this.depositModels[model].name;

      // Only show compare view if it's not the currently active view or Vermögensverwaltugn/MeinVermögen
      if (
        modelName != this.activeDepositModel &&
        modelName != "MeinVermögen" &&
        modelName != "Vermögensverwaltung"
      ) {
        this.$store.dispatch("updateView", {
          view: "compareView",
          payload: true
        });
        this.$emit("triggerCompare", modelName);
      } else {
        this.$store.dispatch("updateView", {
          view: "compareView",
          payload: false
        });

        this.$store.dispatch("updateActiveDeposit", modelName);
      }
      this.$store.dispatch("updateActiveDepositTab", modelName);
      // Hide informationView if it's active
      if (this.$store.getters.getInformationViewState) {
        this.$store.dispatch("updateView", {
          view: "informationView",
          payload: false
        });
      }
    },
    isElementScrollable(el) {
      let curOverflow = el.style.overflow;

      if (!curOverflow || curOverflow === "visible")
        el.style.overflow = "hidden";
      let isOverflowing =
        el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

      el.style.overflow = curOverflow;

      return isOverflowing;
    },
    isElementScrolledToEnd(el) {
      let elementScrollWidth = el.scrollWidth;
      let elementWidth = el.clientWidth;
      let x = el.scrollLeft;
      let offset = 5;
      return x + offset + elementWidth >= elementScrollWidth;
    },
    updateScrollableState() {
      this.isScrollable = this.isElementScrollable(
        this.$refs.depositmodelcontent
      );
    },
    onScroll() {
      this.isScrolledToEnd = this.isElementScrolledToEnd(
        this.$refs.depositmodelcontent
      );
    }
  },
  mounted() {
    this.updateScrollableState();

    if (this.activeDepositModel == "") {
      this.$store.dispatch("updateActiveDeposit", this.recommendedDeposit);
    }

    // set active depositModelTab to current active DepositModel if compare view isn't open
    if (this.$store.getters.getCompareViewState == false) {
      this.$store.dispatch("updateActiveDepositTab", this.activeDepositModel);
    }
  },
  updated() {
    this.updateScrollableState();
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
